module.exports = __webpack_public_path__ + "media/images/icons/date-4644e9a43387d238be391d89dae710ae.svg";